import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {RichTextSchema} from '../richText'
import {LinkSchema} from './link'
import {PrimerComponentLabelSchema} from './primerComponentLabel'
import {AssetSchema} from './asset'
import {safeOptional} from '../../safe-optional'

export const PrimerComponentSectionIntroSchema = buildEntrySchemaFor('primerComponentSectionIntro', {
  fields: z.lazy(() =>
    z.object({
      align: z.literal('start').or(z.literal('center')),
      leadingComponent: safeOptional(AssetSchema),
      leadingComponentSize: z.enum(['small', 'large']).optional(),
      label: safeOptional(PrimerComponentLabelSchema),
      description: safeOptional(RichTextSchema),
      fullWidth: z.boolean().optional(),
      heading: RichTextSchema,
      link: safeOptional(LinkSchema),
      linkVariant: z.enum(['default', 'accent']).optional(),
      htmlId: z.string().optional(),
    }),
  ),
})

export type PrimerComponentSectionIntro = z.infer<typeof PrimerComponentSectionIntroSchema>
